<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="62.7"
    :off-event="offEvent"
    :style-class="classModal"
    :style-class-contain="styleClassContain"
  >
    <ModalHeader
      is-header=""
      style="z-index: 10"
      :title="
        getComponentUiText(
          'app-settings-team-members-modal-mfa-selection-title-1',
        )
      "
      @close="handleCloseModal"
    />
    <div class="md:tw-p-10 tw-p-5 tw-flex tw-flex-col tw-gap-10">
      <div class="tw-flex tw-flex-col tw-gap-[10px] tw-font-[Poppins]">
        <div
          class="tw-font-semibold tw-text-[#211F58] tw-text-[25px] tw-leading-[100%]"
        >
          {{
            getComponentUiText(
              "app-settings-team-members-modal-two-factor-authen-change-your-2fa-1",
            )
          }}
        </div>
        <div class="tw-text-[15px] tw-font-normal tw-font-[Poppins]">
          {{
            getComponentUiText(
              "app-settings-team-members-modal-two-factor-authen-content-1",
            )
          }}
        </div>
        <div class="tw-text-[#231F20] tw-text-[15px] tw-leading-[145%]">
          <div>
            <div
              class="qr-code md:tw-flex md:tw-p-[40px] tw-p-[20px] tw-mt-[40px]"
            >
              <div class="tw-flex md:tw-justify-start tw-justify-center">
                <div class="qr-code-image" style="display: inline-block">
                  <img :src="profileData?.dataURL" />
                </div>
              </div>
              <div class="qr-code-text md:tw-pl-[40px]">
                <div
                  class="tw-text-[16px] tw-text-[#211F58] tw-mb-[10px] tw-font-semibold"
                >
                  {{
                    getComponentUiText(
                      "app-settings-team-members-modal-two-factor-authen-code-1",
                    )
                  }}
                </div>
                <div class="tw-text-[#231F20] tw-text-[15px] tw-font-normal">
                  {{
                    getComponentUiText(
                      "app-settings-team-members-modal-two-factor-authen-unable-to-scan-1",
                    )
                  }}
                </div>
                <CopyInfo
                  class="tw-width-[615px] copy-info-container tw-mt-[25px] tw-px-[20px] tw-py-[10px] tw-bg-[#FFFFFF] tw-rounded-md"
                  :text="profileData?.tempSecret"
                  :style-icon-css="'tw-w-[18px] tw-h-[18px]'"
                />
              </div>
            </div>
            <div
              class="md:tw-flex tw-justify-between tw-items-center tw-pt-[25px]"
            >
              <div
                class="md:tw-mb-[0px] tw-mb-[15px] tw-text-[#231F20] tw-text-[14px] tw-font-medium"
              >
                {{
                  getComponentUiText(
                    "app-settings-team-members-modal-two-factor-authen-enter-gennerate-six-digit-to-scan-1",
                  )
                }}
                <span class="tw-ml-4px tw-text-[#F7553C]">*</span>
              </div>
              <div class="md:tw-w-[520px] tw-w-[100%]">
                <input
                  v-model="code"
                  data-cy="add-mfa-totp-modal-code-input"
                  style="
                    background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
                    border: 1px;
                    letter-spacing: 4px;
                  "
                  type="text"
                  class="tw-border-[#EFF0F1] tw-rounded-md tw-py-[18px] tw-px-[20px] tw-w-[100%] tw-text-[13px] tw-font-normal tw-text-[#231F20]"
                />
              </div>
            </div>
            <div
              class="tw-flex tw-justify-between tw-items-center tw-pt-[40px]"
            >
              <div>
                <b-button
                  data-cy="add-mfa-totp-modal-cancel-button"
                  style="
                    line-height: 90%;
                    border: 2px solid #387dff;
                    height: 39px;
                  "
                  variant="primary"
                  class="tw-w-fit tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
                  type="submit"
                  @click="handleCloseModal"
                >
                  {{
                    getComponentUiText(
                      "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
                    )
                  }}
                </b-button>
              </div>
              <b-button
                data-cy="add-mfa-totp-modal-submit-button"
                style="line-height: 90%; height: 39px"
                variant="primary"
                :class="`tw-w-fit tw-shadow-none ${`tw-bg-[#387DFF]`} tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
                type="submit"
                @click="handleUPdate"
              >
                {{
                  getComponentUiText(
                    "app-assessment-modal-bulk-answer-question-button-text-1",
                  )
                }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalHeader from "@/components/common/modalHeader.vue";
import { ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import CopyInfo from "@/components/common/copyInfo.vue";
import userService from "@/services/user/userService";
import { successStatusCodes } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  profileData: {
    type: Object as () => any,
    default: () => {},
  },
  offEvent: {
    type: Boolean,
    default: false,
  },
});
const code = ref("");
const emit = defineEmits(["update:show", "update:close"]);
let showRef = ref(props.show);
const handleCloseModal = () => {
  store.commit("User/setIsCloseModalProfile", true);
  showRef.value = false;
  emit("update:show", false);
  emit("update:close");
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const success = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const handleUPdate = async () => {
  try {
    if (!code.value) {
      showError(
        getComponentUiText(
          "app-settings-team-members-modal-two-factor-authen-please-enter-gennerate-six-digit-1",
        ),
      );
      return;
    }
    const res: any = await userService.confirmMFAToken({ token: code.value });
    if (res.status === successStatusCodes.OK) {
      const isInternal = props.profileData?.profileData?._isInternal
        ? props.profileData.profileData._isInternal
        : props.profileData.isInternal;
      success(getComponentUiText("app-settings-add-mfa-success-message-1"));
      setTimeout(() => {
        store.commit("User/setIsCloseModalProfile", true);
        showRef.value = false;
        emit("update:show", false);
        emit("update:close");
        EventEmitter.emit(EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS, isInternal);
        EventEmitter.emit(
          EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS,
          isInternal,
        );
      }, 1000);
    }
  } catch (error: any) {
    showError(error.data.error.message);
  }
};
const classModal = {
  background: "rgb(0, 0, 0, 0.5)",
  "border-radius": "6px",
};

const styleClassContain = {
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};
</script>

<style lang="scss" scoped>
.select_option {
  border-radius: 4px;
  border: 1px solid var(--UI-light-sky-soft, #e4f1ff);
  font-family: Poppins;
}
.qr-code {
  align-items: center;
  // padding: 40px;
  background: rgba(239, 240, 241, 0.5);
  border: 1px solid #eeeff0;
  box-sizing: border-box;
  border-radius: 4px;
}

.qr-code-image {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 6px;

  img {
    width: 116px;
    height: 116px;
  }
}

.qr-image {
  position: relative;
  top: 3px;
}

.qr-code-text {
  display: flex;
  flex-direction: column;
  word-break: break-word;
  width: 100%;
}
.copy-info-container {
  max-width: 615px;
}
</style>
